<template>
  <iframe class="app-iframe"
          :id="iframeId"
          :src="formatedAppUrl"
          :data-qa="iframeId"
          :title="iframeId"
          allow="microphone"></iframe>
</template>
<script>
import communicationSdk, { startCommunicationWithSdk } from '@/utils/partnerSdk/communicationSdk';

export default {
  name: 'EmbeddedAppDelegatorIframe',
  props: {
    appId: {
      type: String,
      required: true,
    },
    appCodeName: {
      type: String,
    },
    appUrl: {
      type: String,
      required: true,
    },
    componentData: {
      type: Object,
    },
  },
  data() {
    return {
      appChannel: null,
    };
  },
  created() {
    this.settingChannel();
  },
  computed: {
    iframeId() {
      if (this.$hasFeature('carma_wip')) { // remove when automation is shipit vcita2-4284
        return `app-iframe--${this.appId}`;
      }
      return `${this.appId}-app-iframe`;
    },
    formatedAppUrl() {
      if (this.componentData?.idInQuery) { // only for automation and test app
        let featureEnvName = window.pov_config.VUE_APP_ENV === 'production' ? 'prod' : 'integration';
        if (window.pov_config.VUE_APP_ENV === 'development') { // in case feature env then the url need to be split differently
          featureEnvName = window.pov_config.VUE_APP_FEATURE_ENV_NAME;
        }
        return new URL(`${this.appUrl.replace('{FEATURE_ENV}', featureEnvName)}?widgetUid=${this.appId}`);
      }
      return new URL(this.appUrl);
    },
  },
  methods: {
    settingChannel() {
      this.appChannel = startCommunicationWithSdk({
        appDomain: this.formatedAppUrl.origin,
        iframeId: this.iframeId,
        appId: this.appId,
        appCodeName: this.appCodeName,
      });
      this.appChannel.onmessage = this.handleMessage;
    },
    async handleMessage({ data }) {
      const actionName = data.type;
      const payload = data.data;
      const enrichData = { ...payload, app_code_name: this.appCodeName };
      if (actionName === 'SetState' && payload === 'ready') {
        this.ready();
        this.appChannel.postMessage({ type: actionName, isAck: true });
        return;
      }
      try {
        this.$emit('track', actionName, enrichData);
        const actionResponse = await communicationSdk(actionName, enrichData);
        this.appChannel.postMessage({ type: actionName, isAck: true, data: actionResponse });
      } catch (e) {
        console.error(e);
      }
    },
    ready() {
      this.$emit('ready');
    },
  },
};
</script>
<style scoped lang="scss">
.app-iframe {
  pointer-events: all;
  width: 100%;
  height: 100%;
  border: unset;
  display: block;
}
</style>
